import React from 'react';
import {ActivityButton} from '../components/ActivityButton';

type RegisterPageProps = {};

export const Register: React.FunctionComponent<RegisterPageProps> = ({}) => {
    return (
        <div>
            <h1>Register</h1>
            <form>
                <div className="form-group">
                    <label>Name</label>
                    <input type="text"
                           className="form-control"
                    />
                </div>
                <div className="form-group">
                    <label>Company</label>
                    <input type="text"
                           className="form-control"
                    />
                </div>
                <div className="form-group">
                    <label>Email</label>
                    <input type="text"
                           className="form-control"
                    />
                    <small className="text-muted">This must be your company email. You will receive your login token at this email</small>
                </div>
                <div className="form-group">
                    <label>ABB Contact Email</label>
                    <input type="text"
                           className="form-control"
                    />
                    <small className="text-muted">Provide the email of the ABB Employee who can review your access request</small>
                </div>
                <div className="form-group">
                    <label>Reason for Access</label>
                    <textarea className="form-control" />
                    <small className="text-muted">Describe the workflow(s) you need access to</small>
                </div>
                <div className="form-group">
                    <ActivityButton
                        isActive={false}
                        onClick={() => {}}
                        >Submit</ActivityButton>
                </div>
            </form>
        </div>
    );
};